import { render, staticRenderFns } from "./choosePlan.vue?vue&type=template&id=caf919e8&scoped=true"
import script from "./choosePlan.vue?vue&type=script&setup=true&lang=js"
export * from "./choosePlan.vue?vue&type=script&setup=true&lang=js"
import style0 from "./choosePlan.vue?vue&type=style&index=0&id=caf919e8&prod&lang=scss&scoped=true"
import style1 from "./choosePlan.vue?vue&type=style&index=1&id=caf919e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf919e8",
  null
  
)

export default component.exports